import { useMutation, useQuery, useQueryClient } from 'react-query'
import { userQueryKeys, usersMeQuery } from '../api/userQueries'
import { addCartoDwGrant, revokeCartoDwGrant } from '../api/users'
import { User } from '../types'

export function useCurrentUser(options?: { enabled?: boolean }): User | undefined {
  const enabled = options?.enabled ?? true
  const { data } = useQuery({ ...usersMeQuery, enabled })
  return data
}

export function useAddCartoDwGrantMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: addCartoDwGrant,
    onSuccess: (data, vars) => {
      queryClient.setQueryData<User | undefined>(userQueryKeys.me, (oldUser) => {
        if (oldUser) {
          return { ...oldUser, grantedEmail: vars.email }
        } else {
          return oldUser
        }
      })
    }
  })
}

export function useRevokeCartoDwGrantMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: revokeCartoDwGrant,
    onSuccess: () => {
      queryClient.setQueryData<User | undefined>(userQueryKeys.me, (oldUser) => {
        if (oldUser) {
          return { ...oldUser, grantedEmail: null }
        } else {
          return oldUser
        }
      })
    }
  })
}
